import { FC } from 'react';
import styles from './gridloader.module.sass';

// Pure CSS 4-square grid loader with keyframe blue pulse.
// Four 8px squares in a 2×2 grid; each pulses in turn, a quarter-cycle apart,
// so the light travels around the grid while anything at all is loading.
export interface GridLoaderProps {
  /** Accessible label announced to screen readers. */
  label?: string;
  className?: string;
}

export const GridLoader: FC<GridLoaderProps> = ({ label = 'Loading', className }) => (
  <span className={`${styles.grid} ${className ?? ''}`} role="status" aria-label={label}>
    <i /><i /><i /><i />
  </span>
);

GridLoader.displayName = 'GridLoader';
export default GridLoader;
